<template>
    <div>

      <!-- 支払い期間:住居費 -->
        <div class="bouBox">
            <div class="bou_mochiie_vline" :style="'width:'+mochiieWidth">
                <p class="bou_title">住宅ローン支払総額</p>
            </div>
            <div class="bou_mochiie" :style="'width:'+mochiieWidth" ref="bouMochiie">
                <p class="bou_title loan-text" v-if="showMochiieLoanTextInside">{{ mochiieLoanText }}</p>
                <p class="bou_title kingaku">{{ totalLoanPayment }}万円</p>
                <div class="bou_mochiie_arrow"></div>
                <p class="bou_title kansai">{{ kansaiAge }}歳完済</p>
            </div>
            <p class="loan-text-sp" v-if="!showMochiieLoanTextInside">{{ mochiieLoanText }}</p>
        </div>

    </div>

</template>




<script>

import CalcUtil from "@/store/calcUtil.js"


export default {
    name: "LoanPaymentBar.vue",
    props: [
        'calc',
        'mochiie',
        'mochiieNuri',
        'shuunyuu',
        'shishutsu',
        'lifeEventList',
    ],
    computed: {
        ageStart () {
            return this.$store.state.setainushi.age * 1 //storeを読む
        },
        mochiieRatio(){
            return this.agePosition(this.calc.kansaiNenrei());
        },
        mochiieWidth(){
            return (this.mochiieRatio * 100) +"%";
        },
        totalLoanPayment() {
            return CalcUtil.manYenToOkuYen(this.calc.mochiieTotalLoanPayment);
        },
        kansaiAge() {
            if(typeof(this.calc.kansaiNenrei) == "function"){
                return this.calc.kansaiNenrei();
            }
            return 1;
        },
        mochiieLoanText() {
            if (this.rentalAmount === null) {
                return '';
            }
            return '（借入額：'+ this.rentalAmountLocaleString +'万円、'+ this.$store.state.osumai.kikan +'年、金利 '+ this.$store.state.osumai.kinri +'％）';
        },
        rentalAmount() {
            return CalcUtil.rentalAmount(this.$store.state.osumai);
        },
        rentalAmountLocaleString() {
            if (this.rentalAmount === null) {
                return null;
            }
            return this.rentalAmount.toLocaleString();
        },
    },
    data() {
        return {
            showMochiieLoanTextInside: true,
            yMax: null,
        }
    },
    methods: {
        agePosition(age){
            let start = this.ageStart;
            let end = 90;

            if (age <= this.ageStart) {
                return 0;
            }

            let p = ((age - start) / (end -start));

            return p;
        },
        manYenToOkuYen(manYen) {
            if (manYen < 9999) {
                return manYen;
            }
            let yen = String(manYen);
            let oku = yen.substr(0, yen.length-4);
            return oku+'億'+Number(yen.substr(-4));
        },
    },
    mounted() {

        let rect = this.$refs.bouMochiie.getBoundingClientRect();
        // console.log(rect);
        if (rect.width < 400) {
            this.showMochiieLoanTextInside = false;
        }
    }
}


</script>


<style lang="scss" scoped>

/* 棒グラフ */
.bouBox {
    position: relative;
    padding-top: 15px;

    border-left: 1px solid #000;
    border-right: 1px solid #000;

    font-size: 20px;
    font-weight: bold;

    .loan-text-sp {
        font-weight: normal;
        font-size: 13px;
        margin-bottom: 0;
    }
}

.bou_mochiie_vline {
  position: relative;
  height: 22px;
  width: 100%;
  //border-right: 1px dotted #20ACDC;
}

.bou_mochiie{
  position: relative;
  width: 100%;
  height: 40px;
  color: #fff;
  //background: #6B8DD2;
    background: linear-gradient(to right, #fff, rgb(0, 138, 255)) !important;
    //margin-bottom: 10px;

    .bou_mochiie_arrow {
        content: "";
        position: absolute;
        right: 0;
        width: 0;
        height: 40px;
        margin: auto;
        border-style: solid;
        border-color: #fff #fff #fff #008aff;
        border-width: 20px 0 20px 15px;
        display: block;
    }
}



.bou_title {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    -webkit-transform: translateY(-50%);
    padding: 0 10px;
    color: #333;
    font-size: 15px;
    white-space: nowrap;

    &.loan-text {
        font-weight: normal;
    }

    &.kansai {
        right: -78px;
        font-weight: normal;
    }
}

.kingaku{
    right: 20px;
    color: #fff;
    font-size: 20px;

    .sougaku {
        font-size: 14px;
    }
}

</style>